import { usePostHog } from "@posthog/react";
import { useRouterState } from "@tanstack/react-router";
import React, { useEffect } from "react";

export default function ({
  children,
  domainNotFound = false,
  accommodationNotFound = false,
  placeToGoNotFound = false,
  travelGuideNotFound = false,
}: {
  children?: React.ReactNode;
  domainNotFound?: boolean;
  accommodationNotFound?: boolean;
  placeToGoNotFound?: boolean;
  travelGuideNotFound?: boolean;
}) {
  const router = useRouterState();
  const posthog = usePostHog();
  useEffect(() => {
    console.error("Error", router);
    posthog.capture("Web Error", { location: router.location });
  }, []);
  return (
    <div className="container max-w-5xl mx-auto px-4 py-6 grid grid-cols-1">
      <h1>Error Page</h1>

      <ul className="list">
        {domainNotFound && (
          <div className="list-row text-error rounded-none">
            Domain NOT found
          </div>
        )}
        {accommodationNotFound && (
          <div className="list-row text-error rounded-none">
            Accommodation NOT found
          </div>
        )}
        {placeToGoNotFound && (
          <div className="list-row text-error rounded-none">
            Place to Go NOT found
          </div>
        )}
        {travelGuideNotFound && (
          <div className="list-row text-error rounded-none">
            Travel Guide NOT found
          </div>
        )}
      </ul>
      {children}
    </div>
  );
}
